const basePath: string = process.env.NEXT_PUBLIC_APP_HOMEPAGE ?? '';

export const hasBasePath = () => {
  if (basePath.length > 0) {
    return true;
  } else return false;
};
